import React, { useState } from "react";
import { uploadJudokasFile } from "../../services/competiteursServices";
import { ToastContainer, toast } from "react-toastify";
import { FaUpload, FaTimes, FaFileImport } from "react-icons/fa";
import Button from "../../components/Button/Button";
import { SiMicrosoftexcel } from "react-icons/si";

const UploadJudokasModal = ({
  isOpen,
  onClose,
  competitionId,
  refreshJudokas,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);

  const handleUploadSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      toast.error("Veuillez sélectionner un fichier.");
      return;
    }

    setIsUploading(true);
    try {
      await uploadJudokasFile(competitionId, selectedFile);
      console.log(selectedFile);

      toast.success("Judokas importés avec succès !");
      refreshJudokas();
      onClose();
    } catch (error) {
      toast.error("Erreur lors de l'importation des judokas.");
      console.log(error);
    } finally {
      setIsUploading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center p-4 overflow-y-auto">
      <div className="modal-box bg-white dark:bg-slate-400 p-4 rounded-lg shadow-lg  animate-fade-in transition-all duration-500">
        <h3 className="text-xl font-bold uppercase p-3 mb-4 text-center text-white bg-primary rounded-md shadow">
          Importer des Judokas
        </h3>

        <div className="bg-gray-100 dark:bg-gray-700 text-sm text-gray-800 dark:text-gray-100 p-4 rounded mb-4">
          <h4 className="font-bold text-center mb-2 uppercase text-gray-700 dark:text-white">
            📄 Format attendu du fichier Excel :
          </h4>
          <p className="mb-2">
            Assurez-vous que votre fichier contient les colonnes suivantes avec
            les noms exacts :
          </p>
          <ul className="list-disc pl-5 space-y-1 mb-3">
            <li>
              <strong>LICENCE</strong> : Numéro de licence (facultatif)
            </li>
            <li>
              <strong>NOM</strong> : Nom du judoka
            </li>
            <li>
              <strong>PRENOM</strong> : Prénom du judoka
            </li>
            <li>
              <strong>SEXE</strong> : "M" ou "F"
            </li>
            <li>
              <strong>CLUB</strong> : Nom du club
            </li>
            <li>
              <strong>NAISSANCE</strong> : Date de naissance (format JJ/MM/AAAA)
            </li>
            <li>
              <strong>GRADE</strong> : Grade (optionnel)
            </li>
          </ul>
          <p className="text-sm italic mb-1">
            Les poids seront à saisir plus tard manuellement ou via la pesée.
          </p>
          <p className="text-sm italic mb-2">
            Les judokas déjà présents seront mis à jour s’ils sont reconnus par
            le couple <strong>Nom + Prénom</strong>.
          </p>
          <p className="text-center">
            👉{" "}
            <a
              href="/modele_import_judokas.xlsx"
              className="text-blue-600 hover:underline"
              download
            >
              Télécharger un modèle Excel
            </a>
          </p>
        </div>

        <form onSubmit={handleUploadSubmit}>
          <label
            htmlFor="upload-file"
            className="flex items-center justify-center gap-2 cursor-pointer bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded shadow transition w-full text-center"
          >
            <SiMicrosoftexcel className="text-white text-2xl" />
            <span>
              {selectedFile
                ? selectedFile.name
                : "Sélectionner un fichier Excel .xlsx,.xls,.csv"}
            </span>
          </label>

          <input
            id="upload-file"
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            className="hidden"
          />
          <div className="flex justify-center space-x-2 mt-4">
            <Button
              text="Fermer"
              icon={FaTimes}
              onClick={onClose}
              className="gap-2"
            />

            <Button
              text={isUploading ? "Importation..." : "Importer"}
              icon={FaFileImport}
              type="submit"
              disabled={isUploading}
              className={`gap-2 ${
                isUploading ? "bg-gray-400 cursor-not-allowed" : "btn-primary"
              }`}
            />
          </div>
        </form>
        <ToastContainer />
      </div>
    </div>
  );
};

export default UploadJudokasModal;
